import React, { useState, useEffect } from 'react';
import CustomExpansionPanel from '../../CustomizedComponents/CustomExpansionPanel';
import DetailWrapper from '../../CardRow/DetailWrapper';
import SectionWrapper from '../../CardRow/SectionWrapper';
import DefaultButton from '../../Button/DefaultButton';
import CustomCheckBox from '../../CustomizedComponents/CustomCheckBox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FormattedMessage } from 'react-intl';
import ButtonWrapper from '../../Button/ButtonWrapper';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import CustomSnackBar from '../../CustomizedComponents/CustomSnackbar';
import styled from 'styled-components';
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator';
import CustomLink from '../../CustomizedComponents/CustomLink';
import userRoles from '../../../constants/userRoles';

const LoadingWrapper = styled.div`
  height: 2px;
`;

const TemplatesSettings = ({ notifications, handlers }) => {
  const {
    dayly,
    weekly,
    createTransaction,
    purchaseEnd,
    postNotificationLoading,
    postNotificationError,
    getLoadingDayly,
    getLoadingWeekly,
    getLoadingTransaction,
    getLoadingNotification,
    notificationTypeLEnum,
    user,
  } = notifications;

  const { setDayly, setWeekly, setCreateTransaction, setPurchaseEnd, sendHandler } = handlers;

  const intl = useIntl();
  const [activePannelId, setActivePannelId] = useState(0);
  const [editable, setEditable] = useState(true);
  const [expandedState, setExpandedState] = useState(false);
  const editIcon = 'app.icon.edit';
  const transactionTitle = 'app.settings.warning';
  const purchaseTitle = 'app.settings.endTrade';
  const dailyTitle = 'app.report.prices.daily';
  const weeklyTitle = 'app.report.prices.weekly';
  const success = intl.formatMessage({ id: 'app.action.saved' });
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(success);
  const [issues, setIssues] = useState(null);
  const roles = userRoles;
  const isUserAdmin = user.role === roles.ADMIN;

  const changePannel = (changeId) => {
    setActivePannelId(activePannelId === changeId ? 0 : changeId);
  };
  useEffect(() => {
    if (activePannelId !== 0) {
      setExpandedState(true);
    } else {
      setExpandedState(false);
    }
  }, [activePannelId, setExpandedState]);

  useEffect(() => {
    if (postNotificationError) {
      setMessage(postNotificationError?.data?.message);
      setIssues(postNotificationError?.data?.issues);
    } else {
      setMessage(success);
      setIssues(null);
    }
  }, [postNotificationError, success]);

  return (
    <>
      {(getLoadingDayly || getLoadingWeekly || getLoadingTransaction || getLoadingNotification) && (
        <LoadingWrapper>
          <LoadingIndicator />
        </LoadingWrapper>
      )}
      <CustomExpansionPanel
        id={1}
        text={{ title: transactionTitle, icon: editIcon }}
        active={activePannelId === 1}
        handler={changePannel}
        editable={editable}
        setEditable={setEditable}
        expandedState={expandedState}>
        <TemplatesSettingsDetail
          notification={createTransaction}
          isUserAdmin={isUserAdmin}
          handler={setCreateTransaction}
          notificationTypeId={createTransaction.notificationTypeId}
          sendHandler={sendHandler}
          editable={editable}
          setEditable={setEditable}
          setOpen={setOpen}
          postNotificationLoading={postNotificationLoading}
          notificationTypeLEnum={notificationTypeLEnum}
        />
      </CustomExpansionPanel>

      {!isUserAdmin && (
        <>
          <CustomExpansionPanel
            id={2}
            text={{ title: purchaseTitle, icon: editIcon }}
            active={activePannelId === 2}
            handler={changePannel}
            editable={editable}
            setEditable={setEditable}
            expandedState={expandedState}>
            <TemplatesSettingsDetail
              notification={purchaseEnd}
              handler={setPurchaseEnd}
              notificationTypeId={purchaseEnd.notificationTypeId}
              sendHandler={sendHandler}
              editable={editable}
              setEditable={setEditable}
              setOpen={setOpen}
              postNotificationLoading={postNotificationLoading}
              notificationTypeLEnum={notificationTypeLEnum}
            />
          </CustomExpansionPanel>

          <CustomExpansionPanel
            id={3}
            text={{ title: dailyTitle, icon: editIcon }}
            active={activePannelId === 3}
            handler={changePannel}
            editable={editable}
            setEditable={setEditable}
            expandedState={expandedState}>
            <TemplatesSettingsDetail
              notification={dayly}
              handler={setDayly}
              notificationTypeId={dayly.notificationTypeId}
              sendHandler={sendHandler}
              editable={editable}
              setEditable={setEditable}
              setOpen={setOpen}
              postNotificationLoading={postNotificationLoading}
              notificationTypeLEnum={notificationTypeLEnum}
            />
          </CustomExpansionPanel>

          <CustomExpansionPanel
            id={4}
            text={{ title: weeklyTitle, icon: editIcon }}
            active={activePannelId === 4}
            handler={changePannel}
            editable={editable}
            setEditable={setEditable}
            expandedState={expandedState}>
            <TemplatesSettingsDetail
              notification={weekly}
              handler={setWeekly}
              notificationTypeId={weekly.notificationTypeId}
              sendHandler={sendHandler}
              editable={editable}
              setEditable={setEditable}
              setOpen={setOpen}
              postNotificationLoading={postNotificationLoading}
              notificationTypeLEnum={notificationTypeLEnum}
            />
          </CustomExpansionPanel>
        </>
      )}

      {!postNotificationLoading && message && (
        <CustomSnackBar status={postNotificationError ? 'error' : 'success'} message={message} setOpen={setOpen} open={open} />
      )}
      {!postNotificationLoading &&
        issues &&
        issues.map((issue) => <CustomSnackBar key={issue} status={'error'} message={issue} setOpen={setOpen} open={open} />)}
    </>
  );
};

TemplatesSettings.propTypes = {
  notifications: PropTypes.object,
  handlers: PropTypes.object,
};

const TemplatesSettingsDetail = ({
  notification,
  notificationTypeId,
  handler,
  sendHandler,
  editable,
  setOpen,
  postNotificationLoading,
  notificationTypeLEnum,
  isUserAdmin,
}) => {
  const save = 'app.buttons.save';

  const handleChange = (idButton, id) => {
    if (idButton !== 'cancel') {
      setOpen(true);
      sendHandler(id);
    }
  };

  return (
    <>
      <DetailWrapper>
        <SectionWrapper>
          <FormGroup>
            <FormControlLabel
              control={
                <CustomCheckBox
                  checked={notification.email}
                  disabled={!editable}
                  onChange={(event) => {
                    const target = event.target;
                    handler((oldState) => {
                      return { ...oldState, email: target.checked };
                    });
                  }}
                />
              }
              label={<FormattedMessage id={'app.notification_email'} />}
            />
            {notificationTypeId !== notificationTypeLEnum?.weekly?.id && !isUserAdmin && (
              <FormControlLabel
                control={
                  <CustomCheckBox
                    checked={notification.sms}
                    disabled={!editable}
                    onChange={(event) => {
                      const target = event.target;
                      handler((oldState) => {
                        return { ...oldState, sms: target.checked };
                      });
                    }}
                  />
                }
                label={<FormattedMessage id={'app.notification_sms'} />}
              />
            )}
            <br />
            {notificationTypeId === notificationTypeLEnum?.dayly?.id && <CustomLink text={'app.notification_download_mobilecard.text'} path={'/mobileCard'} />}
          </FormGroup>
          <ButtonWrapper>
            <DefaultButton
              primary={true}
              title={save}
              disabled={!editable}
              onClick={(event) => {
                handleChange(event.currentTarget.id, notificationTypeId);
              }}
              loaders={[postNotificationLoading]}
            />
          </ButtonWrapper>
        </SectionWrapper>
      </DetailWrapper>
    </>
  );
};

TemplatesSettingsDetail.propTypes = {
  notification: PropTypes.object,
  handler: PropTypes.any,
  sendHandler: PropTypes.any,
  notificationTypeId: PropTypes.any,
  editable: PropTypes.bool,
  isUserAdmin: PropTypes.bool,
  setEditable: PropTypes.func,
  setOpen: PropTypes.func,
  postNotificationLoading: PropTypes.bool,
  notificationTypeLEnum: PropTypes.object,
};

export default TemplatesSettings;
